<template>
  <div id="app">
    <Navigation v-if="isValidUser"></Navigation>
    <router-view />
  </div>
</template>

<script>
import Navigation from "./components/Navigation.vue";

export default {
  components: { Navigation },
  computed: {
    isValidUser() {
      return this.$store.getters.isValidUser;
    }
  },
  created() {
    this.$store.commit("setUser");
  }
};
</script>
